module.exports = __webpack_public_path__ + "media/6.9b4e654d.mp3";